import { copy } from "./shared";
import CheckoutForm from "./CheckoutForm";
import "../templates/Template15.css";
import "./CheckoutTemplate15.css";

/*
   Checkout Template 15 — a seamless continuation of sales Template 15
   ("Warm Sunset Soft", light & cream). Reuses Template15.css directly (the
   .clp15-root design system): the real .ws15-nav, the warm .ws15-hero band,
   the .ws15-title, the .ws15-btn/.ws15-btn-p pill button and .ws15-foot
   footer. Only the form + order-summary cards are checkout-specific
   (CheckoutTemplate15.css), styled to match the template's pillowy warm cards.
*/
export default function CheckoutTemplate15({ data = {}, code }) {
  const c = copy(data);

  return (
    <div className="clp15-root">
      {/* NAV — same as the sales page (solid `scr` state for checkout) */}
      <nav className="ws15-nav scr">
        <div className="ws15-wrap ws15-nav-in">
          <span className="ws15-logo">
            {c.logo ? <img src={c.logo} alt="" /> : <span className="cok15-brandtext">{c.brand}</span>}
          </span>
          <span className="cok15-secure">🔒 Secure checkout</span>
        </div>
      </nav>

      {/* HERO — reuses the sales hero band + title */}
      <header className="ws15-hero cok15-hero">
        <div className="ws15-wrap">
          <div className="cok15-hero-in">
            <span className="cok15-eyebrow">Checkout</span>
            <h1 className="ws15-title">
              Complete your <span className="cok15-accent">enrollment</span>
            </h1>
            {c.sub ? <p className="ws15-sub cok15-lead">{c.sub}</p> : null}
          </div>
        </div>
      </header>

      {/* FORM + ORDER SUMMARY — in the template's warm card style */}
      <div className="ws15-wrap">
        <CheckoutForm data={data} code={code} p="cok15" c={c} />
      </div>

      {/* FOOTER — same as the sales page */}
      <footer className="ws15-foot">
        <div className="ws15-wrap ws15-foot-in">
          <div className="cok15-foot">{c.guaranteeOn ? c.guarantee : `© ${c.brand}`}</div>
        </div>
      </footer>
    </div>
  );
}
